// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/retaining-clip-in-automotive-technology/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteRetainingClipInAutomotiveTechnologyEN: PageEntry = {
  id: "example.produkte-halteklammer",
  locale: "en",
  slug: "produkte/retaining-clip-in-automotive-technology",
  seo: {
    title: "Retaining clip in automotive technology | Dietz GmbH",
    description: "Complex bending geometries in one component. The complex geometries were implemented on our CNC-controlled production machine. With low tooling costs and the know-how of our employ",
  },
  type: "post",
  h1: "Retaining clip in automotive technology",
  intro: "Complex bending geometries in one component. The complex geometries were implemented on our CNC-controlled production machine. With low tooling costs and the know-how of our employees, the component could be manufactured",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_drahtbiegeteile_t.jpg", alt: "Retaining clip in automotive technology", width: 1280, height: 1024 }
  ],
};
